export const required = (value) => {

  if (typeof value === 'number') {

    return value > 0 ? '' : 'This field is required';
  }

  return value ? '' : 'This field is required';
};
